import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { updateLanguage } from 'react-localize-redux';
import { browserHistory } from 'react-router';
import Auth from 'j-toker';

import './NavBar.css';

import Subheader from 'material-ui/Subheader';
import {
  MdSettings as SettingsIcon,
  MdAutorenew as Automation,
  MdLanguage as Language,
  MdVpnKey as Key,
  MdStore as Company,
  MdLock as Lock,
  MdPayment as Payment,
  MdAccountBox as UsersIcon,
  MdExtension as ExtentionIcon,
  MdLaunch as ExternalLinkIcon,
} from 'react-icons/md';

import Button from '@material-ui/core/Button';

import LanguageDropDown from 'navigation/LanguageDropDown';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';

import { postLanguage } from 'actions/authenticationActions';

import { localize } from 'react-localize-redux';

import MenuItem from '@material-ui/core/MenuItem';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';

import { colors } from 'helpers/ColorHelper';
import { isSelfService } from 'helpers/Authentication';
import { languageMapping } from 'helpers/constants';

const styles = (theme) => ({
  menuItem: {
    '&:focus': {
      backgroundColor: colors.DISABLED_GRAY,
      '& $primary, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  primary: { fontSize: '13px', color: colors.MENU_ITEM_GRAY },
  icon: { color: colors.ICON_GRAY, textAlign: 'center' },
});

const DO_NOT_DISPLAY = 0;

const SettingItem = ({ classes, text, onClick, icon, shouldShow, name, dataTestid }) => {
  if (shouldShow === false) return null;

  return (
    <MenuItem
      name={name}
      onClick={onClick}
      className={classes.menuItem}
      tabIndex={0}
      data-testid={dataTestid}
    >
      <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
      <ListItemText classes={{ primary: classes.primary }} inset primary={text} />
    </MenuItem>
  );
};

const SettingsPopover = connect(
  (store) => ({
    changePasswordURL: store.userTypes.changePasswordURL,
    isLandlord: store.userTypes.isLandlord,
    userPermissions: store.userTypes.permissions,
    userType: store.userTypes.userType,
    accountProviderIsSSO: store.userTypes.accountProviderIsSSO,
    admin: store.userTypes.admin,
    tenantOverview: store.dashboard.tenantOverview,
    defaultLanguages: store.userTypes.defaultLanguages,
  }),
  (dispatch) => {
    return {
      postLanguage: (value) => {
        dispatch(postLanguage(value));
      },
      updateLanguage: (value) => {
        dispatch(updateLanguage(value));
      },
    };
  }
)(
  class SettingsPopover extends Component {
    state = {
      open: false,
      languageDropDownOpen: false,
    };

    handleToggle = () => {
      this.setState({ open: !this.state.open });
    };

    handleClose = (event) => {
      this.setState({ open: false });
    };

    handleLanguageDropDownToggle = () => {
      this.setState({ languageDropDownOpen: !this.state.languageDropDownOpen });
    };

    handleLanguageDropDownClose = () => {
      this.setState({ languageDropDownOpen: false });
    };

    handleClickAway = () => {
      this.setState({
        open: false,
        languageDropDownOpen: false,
      });
    };

    handlePrivacyPolicyLink = () => {
      window.open(this.props.privacyStatementLink, '_blank', 'noopener');
    };

    goTo = (route) => {
      browserHistory.push(route);
    };

    logUserOut = () => {
      const auth = Auth;
      auth
        .signOut()
        .done((response) => {
          auth.configDfd = null;
          this.performUserLogOut();
        })
        .catch((error) => {
          auth.configDfd = null;
          this.performUserLogOut();
          console.error(error);
        });
    };

    performUserLogOut = () => {
      this.props.logUserOut();
      if (browserHistory.getCurrentLocation().pathname.startsWith('/companies')) {
        browserHistory.push('/companies');
      } else if (browserHistory.getCurrentLocation().pathname.startsWith('/maintenance')) {
        browserHistory.push('/maintenance');
      } else {
        browserHistory.push('/');
      }
    };

    handleLanguageChange = (value) => {
      this.props.postLanguage(value);
      this.props.updateLanguage(value);
    };

    _renderLanguageMenuItem = () => {
      const { classes, currentLanugage, defaultLanguages } = this.props; // currentLanugage is purposely mispelled, misspelled in library
      if (!defaultLanguages || defaultLanguages.length === 0 || defaultLanguages.length === 1)
        return null;

      return (
        <MenuItem
          onClick={this.handleLanguageDropDownToggle}
          buttonRef={(node) => {
            this.languageDropDownRef = node;
          }}
          tabIndex={0}
          style={{ overflow: 'visible' }}
        >
          <ListItemIcon className={classes.icon}>
            <Language size={18} />
          </ListItemIcon>
          <ListItemText
            classes={{ primary: classes.primary }}
            inset
            primary={languageMapping[currentLanugage]}
          />
          <LanguageDropDown
            open={this.state.languageDropDownOpen}
            anchorEl={this.languageDropDownRef}
            handleLanguageChange={this.handleLanguageChange}
            handleClose={this.handleLanguageDropDownClose}
            defaultLanguages={defaultLanguages}
          />
        </MenuItem>
      );
    };

    render() {
      const { classes } = this.props;
      const { open } = this.state;

      const style = {
        container: {
          position: 'relative',
        },
        dropDown: {
          fontSize: '13px',
          color: '#656565',
          width: '100%',
          marginLeft: '15px',
          marginTop: '10px',
        },
        settings_icon: {
          height: 25,
          width: 25,
          color: colors.DARK_GRAY,
        },
        subheader: {
          lineHeight: 0,
          padding: '10px 16px 10px 16px',
          fontSize: '16px',
        },
        button: {
          padding: '8px',
          minWidth: '40px',
          color: colors.MENU_ITEM_GRAY,
        },
      };

      return (
        <ClickAwayListener onClickAway={this.handleClickAway}>
          <div style={style.container}>
            <Button
              aria-haspopup="true"
              aria-label="Settings"
              data-testid="header-settings-button"
              onClick={this.handleToggle}
              buttonRef={(node) => {
                this.anchorEl = node;
              }}
              style={style.button}
            >
              <SettingsIcon size={25} style={style.settings_icon} id="settings_icon" />
            </Button>
            <Popper
              open={open}
              anchorEl={this.anchorEl}
              transition
              disablePortal
              placement="left-end"
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  id="menu-list-grow"
                  style={{
                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                  }}
                >
                  <Paper>
                    <MenuList>
                      <Subheader inset={false} style={style.subheader}>
                        <span tabIndex="-1">
                          <SettingsIcon size={18} style={{ verticalAlign: 'text-bottom' }} /> &nbsp;{' '}
                          {this.props.translate('settings')}
                        </span>
                      </Subheader>

                      {this._renderGlobalSettings()}

                      <SettingItem
                        classes={classes}
                        name="logout"
                        dataTestid="header-logout-button"
                        text={this.props.translate('settings.logout')}
                        icon={<Lock size={18} />}
                        tabIndex={0}
                        onClick={() => {
                          this.handleClose();
                          this.logUserOut();
                        }}
                      />

                      {this._renderLanguageMenuItem()}
                    </MenuList>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
        </ClickAwayListener>
      );
    }

    _renderGlobalSettings = () => {
      if (isSelfService(this.props.userPermissions)) return null;

      const { classes, admin, accountProviderIsSSO, userType } = this.props;

      return (
        <div>
          <SettingItem
            classes={classes}
            name="privacy-policy"
            text={this.props.translate('settings.privacyPolicy')}
            icon={<ExternalLinkIcon size={18} />}
            tabIndex={0}
            shouldShow={['lead'].includes(this.props.userType)}
            onClick={this.handlePrivacyPolicyLink}
          />
          {this._renderChangePasswordSettingItem(accountProviderIsSSO, userType)}

          <SettingItem
            classes={classes}
            text={this.props.translate('settings.automation')}
            onClick={() => {
              this.handleClose();
              this.goTo('/companies/automation');
            }}
            icon={<Automation size={18} />}
            shouldShow={['agent'].includes(this.props.userType)}
            tabIndex={0}
          />

          {admin === true && (
            <Fragment>
              <SettingItem
                classes={classes}
                text={this.props.translate('settings.companyProfile')}
                onClick={() => {
                  this.handleClose();
                  this.goTo('/companies/company_details');
                }}
                icon={<Company size={18} />}
                shouldShow={
                  this.props.isLandlord &&
                  this.props.userPermissions.company_settings !== DO_NOT_DISPLAY
                }
                tabIndex={0}
              />

              <SettingItem
                classes={classes}
                text={this.props.translate('settings.integrations')}
                onClick={() => {
                  this.handleClose();
                  this.goTo('/companies/integrations');
                }}
                icon={<ExtentionIcon size={16} />}
                shouldShow={
                  this.props.isLandlord &&
                  this.props.userPermissions.company_settings !== DO_NOT_DISPLAY
                }
                tabIndex={0}
              />

              <SettingItem
                classes={classes}
                shouldShow={
                  this.props.isLandlord &&
                  this.props.userPermissions.company_settings !== DO_NOT_DISPLAY
                }
                text={this.props.translate('settings.billing')}
                onClick={() => {
                  this.handleClose();
                  this.goTo('/companies/billing');
                }}
                icon={<Payment size={18} />}
                tabIndex={0}
              />
            </Fragment>
          )}

          <SettingItem
            classes={classes}
            shouldShow={admin === true && userType === 'maintenance'}
            text={this.props.translate('settings.users')}
            onClick={() => {
              this.handleClose();
              this.goTo('/maintenance/users');
            }}
            icon={<UsersIcon size={18} />}
            tabIndex={0}
          />
        </div>
      );
    };

    _renderChangePasswordSettingItem = (accountProviderIsSSO, userType) => {
      if (this.isCurrentLocationChangePassword()) return null;

      if (accountProviderIsSSO === true && userType === 'agent') return null;

      const { classes } = this.props;

      return (
        <SettingItem
          classes={classes}
          text={this.props.translate('settings.changePassword')}
          onClick={() => {
            this.handleClose();

            browserHistory.push(this.props.changePasswordURL);
          }}
          icon={<Key size={18} />}
          tabIndex={0}
        />
      );
    };

    isCurrentLocationChangePassword = () => {
      return browserHistory.getCurrentLocation().pathname.includes('_change_password_reset');
    };
  }
);

export default localize()(withStyles(styles)(SettingsPopover));
